import { useTranslation } from "@msuite/ui/localization";
import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { IncomingInvoicePaymentRunListItem } from "@msuite/utils/types";
import { PaymentFileDownloadButton } from "@/components/incoming-invoices";

/**
 * The file, downloaded again as it was handed out. A run whose payments were all settled by offset
 * transferred nothing and has no file, which the disabled button says.
 */
export function RowActions({ cell }: CellContext<IncomingInvoicePaymentRunListItem, "actions">) {
	/** Context */
	const { t } = useTranslation();

	/** Computed */
	const hasFile = cell.row.original.transactionCount > 0;

	/** Render */
	return (
		<RowActionsWrapper>
			<PaymentFileDownloadButton
				paymentRunId={cell.row.original.id}
				size="xxs"
				disabledReason={hasFile ? null : t("incoming_invoices.payments.offsets.no_file")}
			/>
		</RowActionsWrapper>
	);
}
